import { initializeApp } from "firebase/app"
import { getFirestore,serverTimestamp } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import {getAuth} from 'firebase/auth'

const firebaseConfig = {

    apiKey: "AIzaSyDI0aIceqpJ4NoYE_w0mH7bRjDdIQ2uoIg",
  
    authDomain: "thedojosite-50966.firebaseapp.com",
  
    projectId: "thedojosite-50966",
  
    storageBucket: "thedojosite-50966.appspot.com",
  
    messagingSenderId: "679541329232",
  
    appId: "1:679541329232:web:ec3d144b6f2e2800f33055"
  
  };

  // init firebase
  initializeApp(firebaseConfig)

  //init firestore
  const db = getFirestore()

  //init firebaseauth
  const auth = getAuth()

  //timestamp
  const timestamp = serverTimestamp()

  //storage
  const storage = getStorage();

  
  export { db, auth, timestamp, storage}
